import {
  jb_media_overlay_css_default
} from "./chunk.KVLMQ6LF.js";
import {
  JbModal
} from "./chunk.NTO5HUBR.js";
import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.A7Z76YXE.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Animatable
} from "./chunk.V3FEQEPV.js";
import {
  parseHashToObject,
  recenterNavItems
} from "./chunk.JTCOOS2A.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-media-overlay/jb-media-overlay.ts
var JbMediaOverlay = class extends Initiable(Animatable(i)) {
  constructor() {
    super(...arguments);
    this.open = false;
    this._mediaOverlay = {
      content: null,
      overlay: null,
      innerContent: null,
      OVERLAY_SELECTOR: ".overlay-template",
      OVERLAY_CONTENT_SELECTOR: ".media-overlay",
      OVERLAY_INNER_CONTENT_SELECTOR: ".media-overlay__content",
      MEDIA_TEMPLATE_SELECTOR: "#media-overlay__media-template",
      DESCRIPTION_TEMPLATE_SELECTOR: "#media-overlay__description-template"
    };
  }
  firstUpdated() {
    this._init();
    if (this.url) {
      this._fetchDataFromApi(this.url);
    } else if (this.overlayContent) {
      this._generateMediaHTML(this.overlayContent);
      this._generateDescriptionHTML(this.overlayContent);
    }
    this.dispatchEvent(
      new CustomEvent("jb-stackable:register-outro-callback", {
        bubbles: true,
        composed: true,
        detail: {
          callback: async () => {
            window.history.replaceState("", "", window.location.pathname);
          }
        }
      })
    );
    this.addEventListener("jb-reveal:contentRevealed", () => {
      const video = this.shadowRoot.querySelector("jb-video");
      if (!video) return;
      video._plyr.play();
      video._plyr.on("ready", () => {
        video._plyr.play();
      });
    });
    document.addEventListener("jb-modal:close", () => {
      const video = this.shadowRoot.querySelector("jb-video");
      if (!video) return;
      video._plyr.pause();
    });
  }
  _dom() {
    this._mediaOverlay.content = this.renderRoot.querySelector(
      this._mediaOverlay.OVERLAY_CONTENT_SELECTOR
    );
    if (this._mediaOverlay.content) {
      this._mediaOverlay.innerContent = this._mediaOverlay.content.querySelector(
        this._mediaOverlay.OVERLAY_INNER_CONTENT_SELECTOR
      );
      this._mediaOverlay.overlay = this._mediaOverlay.content.closest(
        this._mediaOverlay.OVERLAY_SELECTOR
      );
    }
  }
  _fetchDataFromApi(url) {
    fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not OK");
      }
      return response.json();
    }).then((data) => {
      this._populateMediaOverlay(data);
    });
  }
  _generateDescriptionHTML(data) {
    const descriptionTemplate = this._mediaOverlay.overlay.querySelector(
      this._mediaOverlay.DESCRIPTION_TEMPLATE_SELECTOR
    );
    const descriptionClone = descriptionTemplate.content.cloneNode(true);
    const description = descriptionClone.querySelector(".media-overlay__description");
    description.innerHTML = data.description;
    this._mediaOverlay.innerContent.appendChild(descriptionClone);
  }
  _generateMediaHTML(data) {
    const videoTemplate = this._mediaOverlay.overlay.querySelector(this._mediaOverlay.MEDIA_TEMPLATE_SELECTOR);
    const videoClone = videoTemplate?.content.cloneNode(true);
    const media = videoClone.querySelector(".media-overlay__media");
    media.innerHTML = data.media;
    this._mediaOverlay.innerContent.appendChild(videoClone);
  }
  _init() {
    this._dom();
  }
  _populateMediaOverlay(data) {
    this._generateMediaHTML(data);
    this._generateDescriptionHTML(data);
  }
  render() {
    return b`
      <section class="overlay-template">
        <div class="media-overlay">
          <div class="media-overlay__content"></div>
        </div>

        <template id="media-overlay__media-template">
          <div class="media-overlay__media"></div>
        </template>

        <template id="media-overlay__description-template">
          <div class="media-overlay__description"></div>
        </template>
      </section>
    `;
  }
};
JbMediaOverlay.styles = [reset_css_default, jb_media_overlay_css_default];
__decorateClass([
  n({ type: Boolean })
], JbMediaOverlay.prototype, "open", 2);
__decorateClass([
  n()
], JbMediaOverlay.prototype, "overlayContent", 2);
__decorateClass([
  n()
], JbMediaOverlay.prototype, "url", 2);
JbMediaOverlay = __decorateClass([
  customElement("jb-media-overlay")
], JbMediaOverlay);
bindEvents();

// src/components/jb-media-overlay/jb-media-overlay-controller.ts
var mediaLinksRegister = {};
var JbMediaOverlayController = class {
  constructor() {
    this.mediaOverlay = void 0;
    this.overlay = void 0;
  }
  async close() {
    if (this.mediaOverlay) {
      await this.mediaOverlay.hide();
      enableBodyScroll(this.mediaOverlay);
      recenterNavItems();
    }
    if (this.overlay) {
      this.overlay.unstack();
    }
    this.overlay = void 0;
  }
  handleHashChange() {
    const hash = window.location.hash.substring(1);
    if (hash === "" || !hash.includes("overlayMedia")) {
      this.close();
      return;
    }
    const hashParams = parseHashToObject(hash);
    const mediaId = hashParams.overlayMedia;
    if (!mediaId) {
      this.close();
      return;
    }
    const endpoint = document.body.dataset.mediaOverlayEndpoint;
    if (!endpoint) {
      this.close();
      return;
    }
    mediaLinksRegister[mediaId] = endpoint.replace(":mediaId", mediaId);
    const url = mediaLinksRegister[mediaId];
    this.mediaOverlay = new JbMediaOverlay().init({
      props: { url, slot: "content" }
    });
    const ariaLabels = {
      label: hashParams.overlayLabel ? hashParams.overlayLabel : void 0,
      close: hashParams.overlayClose ? hashParams.overlayClose : void 0
    };
    this.overlay = new JbModal().init({
      props: {
        color: "white",
        hasLogo: false,
        newAnimation: true,
        ariaLabels
      },
      childNodes: [this.mediaOverlay]
    });
    if (this.overlay) {
      this.overlay.stack();
      customElements.whenDefined("jb-media-overlay").then(async () => {
        setTimeout(() => {
          this.mediaOverlay.contentChildren = Array.from(
            this.mediaOverlay.shadowRoot.querySelectorAll(".media-overlay")
          );
        }, 0);
        disableBodyScroll(this.mediaOverlay, { allowTouchMove: () => true });
        recenterNavItems();
        await this.mediaOverlay.reveal();
      });
    }
  }
  open(event) {
    const customEvent = event;
    if (customEvent.detail.id || customEvent.detail.media) {
      customEvent.stopPropagation();
      customEvent.detail.clickEvent.preventDefault();
      customEvent.detail.clickEvent.stopPropagation();
      if (customEvent.detail.id) {
        const baseUrl = window.location.href.split("#")[0];
        let newUrl = `${baseUrl}#overlayMedia=${customEvent.detail.id}`;
        if (customEvent.detail.overlayAriaLabels?.label) {
          newUrl += `&overlayLabel=${customEvent.detail.overlayAriaLabels.label}`;
        }
        if (customEvent.detail.overlayAriaLabels?.close) {
          newUrl += `&overlayClose=${customEvent.detail.overlayAriaLabels.close}`;
        }
        window.open(newUrl, "_self");
      } else {
        const overlayContent = {
          media: customEvent.detail.media,
          description: customEvent.detail.description
        };
        this.mediaOverlay = new JbMediaOverlay().init({
          props: { overlayContent, slot: "content" }
        });
        this.overlay = new JbModal().init({
          props: {
            color: "white",
            hasLogo: false,
            newAnimation: true,
            returnFocusTo: customEvent.detail.linkTag,
            ariaLabels: {
              label: customEvent.detail.ariaLabels?.label ?? void 0,
              close: customEvent.detail.ariaLabels?.close ?? void 0
            }
          },
          childNodes: [this.mediaOverlay]
        });
        if (this.overlay) {
          this.overlay.stack();
          customElements.whenDefined("jb-media-overlay").then(async () => {
            setTimeout(() => {
              this.mediaOverlay.contentChildren = Array.from(
                this.mediaOverlay.shadowRoot.querySelectorAll(".media-overlay")
              );
            }, 0);
            disableBodyScroll(this.mediaOverlay, { allowTouchMove: () => true });
            recenterNavItems();
            await this.mediaOverlay.reveal();
          });
        }
      }
    }
  }
};
var controller = new JbMediaOverlayController();
function bindEvents() {
  document.addEventListener("jb-modal:close", () => {
    controller.close();
  });
  document.body.addEventListener("jb-link:initialized", (event) => {
    const customEvent = event;
    if (!customEvent.detail.id) {
      return;
    }
    mediaLinksRegister[customEvent.detail.id] = customEvent.detail.url;
  });
  document.addEventListener("jb-link:clicked", (event) => {
    controller.open(event);
  });
  window.onhashchange = () => {
    controller.handleHashChange();
  };
  window.setTimeout(() => {
    controller.handleHashChange();
  }, 0);
}

export {
  bindEvents,
  JbMediaOverlay
};
